import CardWithTitle from 'components/CardWithTitle';
import DetailsPage from 'components/DetailsPage';
import Breadcrumb from 'components/DetailsPage/Breadcrumb';
import { useContactById } from 'core/api/contacts';
import { getContactLabel } from 'core/useCases/contacts/utils';
import useResponsive from 'hooks/responsive';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { getNumericDate } from 'utils/dateTimeFormat';
import Activities from './Activities';
import ContactMapping from '../ContactMapping';
import Information from './Information';
import LinkedApplications from './LinkedApplications';
import RecommendedContacts from './RecommendedContacts';
import { SBreadcrumbRight } from './styles';

type ContactDetailsProps = {
    id: string;
};

const ContactDetails: FC<ContactDetailsProps> = ({ id }) => {
    const { t } = useTranslation();
    const contact = useContactById(id).data;
    const { isMobile } = useResponsive();

    return (
        <div>
            {contact && (
                <DetailsPage
                    activities={<Activities contact={contact} />}
                    breadcrumb={
                        <>
                            {!isMobile && (
                                <Breadcrumb
                                    linkLabel={t('contact-details.my-network')}
                                    linkPath="/contacts"
                                    secondLabel={getContactLabel(contact, t)}
                                />
                            )}
                            <SBreadcrumbRight>{`${t('contact-details.added')} ${getNumericDate(
                                contact.createdDate,
                            )}`}</SBreadcrumbRight>
                        </>
                    }
                    information={<Information contact={contact} />}
                    secondaryActivities={<LinkedApplications contactId={id} />}
                    secondaryInformation={
                        <>
                            <RecommendedContacts contactId={id} />
                            <CardWithTitle label={t('vue-mapping.title')}>
                                <ContactMapping contactId={id} />
                            </CardWithTitle>
                        </>
                    }
                />
            )}
        </div>
    );
};

export default ContactDetails;
